import React from 'react';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { Button, FontIcon, IButtonProps, SvgIcon } from '@gik/ui';
import { inkindPageTourSelectors } from '@gik/inkind-page';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/inkind-page/i18n/en';

export interface IAddInkindUserUpdateButtonProps extends IButtonProps {
  iconOnly?: boolean;
}

const blockName = 'add-inkind-user-update-button';

export default function AddInkindUserUpdateButton({ iconOnly, ...buttonProps }: IAddInkindUserUpdateButtonProps) {
  const bem = useBemCN(blockName);
  const { t } = useTranslation();

  if (iconOnly) {
    return (
      <Button {...bem()} {...buttonProps} variant={'secondary'} circle>
        <SvgIcon name={'Plus'} />
      </Button>
    );
  } else {
    return (
      <Button
        {...bem()}
        {...buttonProps}
        id={inkindPageTourSelectors.addUpdate}
        variant={'secondary'}
        prepend={<FontIcon name={'bullhorn'} size="lg" />}
      >
        {t(translationKeys.AddUpdateButtonLabel)}
      </Button>
    );
  }
}
